/* ------------------------------------------------------------------------
Copyright (c) 2016, VoiceVibes, Inc

VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
All contents of this file are proprietary and confidential. No part of
any of the contents of this file may be disclosed in any manner to
a third party without the prior written consent of VoiceVibes, Inc.
Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

<template>
  <div
    v-if="results && results.scores"
    class="score-container svg-container"
    tabindex="-1"
    v-html="vibesSvg"
  />
</template>

<script>
import ChartHelper from '../utils/ChartHelper';

export default {
  mixins: [ChartHelper],
  props: ['recording', 'wavesurfer', 'speakerNum', 'metric', 'tooltipId'],
  data() {
    return {
      vibeLinkIds: [],
      chartIds: [],
    };
  },
  computed: {
    vibesSvg() {
      if (!this.results.scores || !this.results.scores.vibes) return '';

      const centerX = 220;
      const centerY = 200;
      const maxRadius = 150;
      const minValue = .5;

      const
        vibes = this._.pick(this.results.scores.vibes, this.configs[this.metric].activeVibes),
        // we must check whether vibes timeseries data exists, since it won't in older recordings
        wavesurferVibesChart = (this.results.timestamped && this.results.timestamped.vibes),
        vibeLinkStyle = (wavesurferVibesChart) ? '' : '', // TODO: Restore "cursor: pointer;"
        chartType = (this.metric === 'positiveVibes') ? 'positive' : 'negative',
        chartId = (this.metric === 'positiveVibes') ? 'positiveVibesChartSVG' : 'negativeVibesChartSVG',
        vibesArray = this._.map(vibes, (value, vibe) => {
          return {
            vibe,
            value
          };
        }),
        angleIncrement = 360 / vibesArray.length,
        axes = this._.map(vibesArray, (vibe, index) => {
          return {
            end: this._arcPoint(centerX, centerY, maxRadius, 90 - index * angleIncrement),
            labelPos: this._arcPoint(centerX, centerY, maxRadius + 10, 90 - index * angleIncrement),
            label: vibe.vibe
          };
        }),
        points = this._.map(vibesArray, (vibe, index) => {
          return this._arcPoint(centerX, centerY, Math.max(minValue,vibe.value)/10*maxRadius, 90 - index*angleIncrement);
        }),
        pointsPolyline = this._.map(points, p => `${p.x} ${p.y}`).join(','),
        webs = this._.map([2,4,6,8,10], (webValue) => {
          return this._.map(this._.range(vibesArray.length + 1), index => {
            const p = this._arcPoint(centerX, centerY, webValue/10*maxRadius, 90 - index * angleIncrement);
            return `${p.x} ${p.y}`;
          });
        });

      // Queue up our tooltip events
      this.chartIds.push(chartId);

      let svg = `<svg viewBox="0 0 440 400" id="${chartId}" class="vibes-chart vibes-chart-${chartType}">`;

      svg += '<g>';
      for (let i=0; i<webs.length; i++) {
        let webPolyline = webs[i].join(',');
        svg += `<polyline points="${webPolyline}" fill="none" stroke="#e5e5e5" stroke-width="1" />`;
      }

      for (let j=0; j<axes.length; j++) {
        let axis = axes[j],
          vibeLinkId = `vv-vibe-${axis.label}`,
          hotSpotHandler = (evt) => {
            if (evt.shiftKey) {
              this.showWavesurferVibe(this.results.timestamped.vibes, axis.label);
            }

            return false;
          };

        this.vibeLinkIds.push({vibeLinkId, hotSpotHandler, vibe: axis.label}); // save for later so we can register the events

        svg += `
        <g>
          <line x1="220" y1="200" x2="${axis.end.x}" y2="${axis.end.y}" fill="none" stroke="#999" stroke-width="3" />
          <text x="${axis.labelPos.x}" y="${axis.labelPos.y}" stroke="#fff" stroke-width="8" text-anchor="middle" font-size="15">
            ${axis.label}
          </text>
          <text id="${vibeLinkId}" style="${vibeLinkStyle}" x="${axis.labelPos.x}" y="${axis.labelPos.y}" fill="#333" text-anchor="middle" font-size="15">
            ${axis.label}
          </text>
        </g>`;
      }
      svg += '</g>';

      svg += `<g><polyline class="vibes-chart-poly" points="${pointsPolyline}" />`;

      for (let k=0; k<points.length; k++) {
        let point = points[k];
        svg += `<line x1="220" y1="200" x2="${point.x}" y2="${point.y}" fill="none" stroke="#fff" stroke-width="3" />`;
      }

      svg +=  '</g></svg>';
      return svg;
    }
  },
  mounted() {
    // Add events
    this.chartIds.forEach((chartId) => {
      this._addTooltip(chartId, this.recording, this.metric);
    });
    this.vibeLinkIds.forEach((obj) => {
      this._addEvent(obj.vibeLinkId, 'click', obj.hotSpotHandler);
    });
  },
};
</script>
